import { render, staticRenderFns } from "./HomeMenuAfiliados.vue?vue&type=template&id=6707d307"
import script from "./HomeMenuAfiliados.vue?vue&type=script&lang=ts"
export * from "./HomeMenuAfiliados.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports